// Static class list so Tailwind's JIT can detect every delay used in staggered reveals.
const STAGGER_DELAYS = [
  'delay-0',
  'delay-100',
  'delay-200',
  'delay-300',
  'delay-[400ms]',
  'delay-500',
  'delay-[600ms]',
  'delay-700',
] as const;

export const staggerDelay = (index: number): string =>
  STAGGER_DELAYS[Math.min(Math.max(index, 0), STAGGER_DELAYS.length - 1)];
